import React from 'react';
import { createPortal } from 'react-dom';
import { AiOutlineClose } from 'react-icons/ai';
import ALERT_IMAGE from '../../../assets/images/modal_top_image.png';

interface ModalProps {
  title: string;
  children: React.ReactNode;
  onClose: () => void;
  overFlowUnset?: boolean;
  actions?: React.ReactNode;
}

export const SIMPLModal: React.FC<ModalProps> = ({
  children,
  actions,
  title,
  onClose,
  overFlowUnset = false,
}) => {
  const modalRoot = document.getElementById('root') as HTMLElement;

  const modalScrollClasses = [
    'bg-white',
    'mx-auto',
    'rounded-xl',
    'min-h-[150px]',
    'min-w-[400px]',
    'max-w-full',
    'max-h-screen',
    'z-[50]',
    !overFlowUnset && 'overflow-auto',
  ]
    .filter(Boolean)
    .join(' ');

  return createPortal(
    <div className="absolute flex items-center justify-center h-screen top-0 left-0 bg-black bg-opacity-60 w-full transition-opacity z-40">
      <div className="flex flex-col w-full px-2 py-2 relative">
        <div id="modal-popup-container" />
        <div id="modal-scroll-container" className={modalScrollClasses}>
          {/* Top Image */}
          <div className="w-[633px] h-[32px]">
            <img src={ALERT_IMAGE} alt="top_image" className="w-full h-full" />
          </div>

          {/* Header */}
          <div className="flex items-center justify-between w-full h-auto p-6 gap-2">
            <div
              className="text-xl flex-1 font-semibold flex items-end"
              data-testid="modal-title"
            >
              <h3 className="w-full h-[36px] gap-0 font-arial text-[28px] font-normal leading-[36px] text-left text-Foundation/Heading">
                {title}
              </h3>
            </div>
            <div className="w-[24px] h-[24px] flex items-center justify-center">
              <AiOutlineClose onClick={onClose} />
            </div>
          </div>

          {/* Content */}
          <div
            className="mt-4 w-[633px] h-auto p-6 pb-10 pt-6 gap-0 border-b border-[#CED0D5]"
            data-testid="modal-content"
          >
            <div className="gap-0 font-arial text-[16px] font-normal leading-[28px] text-left">
              {children}
            </div>
          </div>

          {/* Actions */}
          <div className="w-full h-auto flex flex-row justify-end items-center p-6 px-10">
            {actions}
          </div>
        </div>
      </div>
    </div>,
    modalRoot
  );
};
